import React from 'react';
import styled from 'styled-components';
import { screenXsMax, spacer40 } from '@spotify-internal/encore-foundation';
import { Type } from '@spotify-internal/encore-web';
import { Box } from '../../ui';
import { FAQItem } from './FAQItem';
import { SearchHit } from '../../Search';

const HelpFAQComponent = styled(Box)``;

const Headline = styled(Type.h1).attrs({
  variant: Type.heading2,
  weight: Type.bold,
})<{}>`
  padding-bottom: ${spacer40};
`;

const FAQWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-content: flex-start;
  width: 100%;

  @media (max-width: ${screenXsMax}) {
    flex-flow: column;
  }
`;

export type HelpFAQType = {
  headline?: string;
  items?: SearchHit[];
};

export const HelpFAQ: React.FC<HelpFAQType> = ({
  headline = 'Top help articles',
  items = [],
}) => {
  return (
    <HelpFAQComponent data-testid="help-faq">
      <Headline>{headline}</Headline>
      <FAQWrapper>
        {items?.length &&
          items.map(
            (item, key) =>
              item && (
                <React.Fragment key={key}>
                  <FAQItem {...item} />
                </React.Fragment>
              ),
          )}
      </FAQWrapper>
    </HelpFAQComponent>
  );
};
